import { createSlice } from "@reduxjs/toolkit";

// Backend page size (fixed)
const DEFAULT_PAGE_SIZE = 1;

const initialState = {
  status: null,
  search: null,
  cursor: 0,
  pagination: DEFAULT_PAGE_SIZE,
};

const inventorySpareLotListFilterSlice = createSlice({
  name: "inventorySpareLotListFilter",
  initialState,
  reducers: {
    /** Set or update filters (resets cursor if changed) */
    setInventorySpareLotListFilter: (state, action) => {
      let shouldResetCursor = false;

      Object.entries(action.payload).forEach(([key, value]) => {
        if (value !== undefined && state[key] !== value) {
          state[key] = value;
          shouldResetCursor = true;
        }
      });

      if (shouldResetCursor) {
        state.cursor = 0;
      }
    },

    /** Used by infinite scroll */
    setInventorySpareLotListCursor: (state, action) => {
      state.cursor = action.payload;
    },

    /** Reset everything */
    clearInventorySpareLotListFilters: () => ({
      ...initialState,
    }),
  },
});

export const {
  setInventorySpareLotListFilter,
  setInventorySpareLotListCursor,
  clearInventorySpareLotListFilters,
} = inventorySpareLotListFilterSlice.actions;

/** Selector */
export const selectInventorySpareLotFilterState = (state) =>
  state.inventorySpareLotListFilter;

export default inventorySpareLotListFilterSlice.reducer;
